$(document).ready(() => {
	$('.servicefilter__item').height('');
});

$('.servicefilter__item')
	.hover(function () {
		$(this).find('.servicefilter__item--service-logo').css('opacity', 0);
		$(this).find('.servicefilter__item--service-link').css('opacity', 1);
	}, function () {
		$('.servicefilter__item--service-logo').css('opacity', 1);
		$('.servicefilter__item--service-link').css('opacity', 0);
	});



// WEBPACK FOOTER //
// ./temp/components/services-filter/.variant/base/index.js